export default "__VITE_ASSET__B3pz$9un__"